import {
  takeEvery, call, put, fork
} from 'redux-saga/effects';
import { loadIscilik, saveIscilik,removeIscilikAll } from 'src/utils/storage/Labour';
import * as actions from '../actions/labourActions';
import * as api from '../api/afterSalesDataServices';

function* getLabours(kulModelKodu, garantiTipi, hizmetKodu,WorkOrderId) {
  try {
    if (!kulModelKodu.kulModelKodu) {
      throw new Error('Model Kodu Girilmemiş');
    }
    let data = loadIscilik(kulModelKodu.kulModelKodu);
    if (data.length === 0 && window.navigator.onLine) {
      const result = yield call(api.getLabours, kulModelKodu, kulModelKodu.garantiTipi, kulModelKodu.hizmetKodu,WorkOrderId);
      data = result.data === '' ? [] : result.data;
      saveIscilik(kulModelKodu.kulModelKodu, data);
    }
    yield put(actions.getLabourSuccess(data));
  } catch (error) {
    yield put(actions.setLabourError(error));
  }
}

function* resetLabours(kulModelKodu) {
  try {
    if (!kulModelKodu.kulModelKodu) {
      removeIscilikAll()
    }
    else{
      saveIscilik(kulModelKodu.kulModelKodu, []);
    }
  } catch (error) {
  }
}

function* watchGetLabourRequest() {
  yield takeEvery(actions.Types.GET_LABOUR_REQUEST, getLabours);
}

function* watchGetLabourResetRequest() {
  yield takeEvery(actions.Types.RESET_LABOURS, resetLabours);
}

const labourSagas = [fork(watchGetLabourRequest),fork(watchGetLabourResetRequest)];

export default labourSagas;
